import * as React from "react";
import { IProfile } from "../../api/models/IProfile";

type TAccountManagerMode = 'view' | 'edit' | 'password';

interface IAccountContext {
  mode: TAccountManagerMode;
  setMode: (mode: TAccountManagerMode) => void;
  
  updateProfile: (profile: IProfile) => Promise<boolean>;
}

const AccountContext = React.createContext<IAccountContext | null>(null);

const useAccountContext = (): IAccountContext => {
  const ctx = React.useContext(AccountContext);
  if (!ctx) throw new Error('useAccountContext must be used inside an <AccountContext> provider.');
  return ctx;
}

export { AccountContext, IAccountContext, TAccountManagerMode, useAccountContext }



